import baseProps from './ChooseCredentialsDataProvider.props';

// name of fields in CreationWizard root component state
export default {
	...baseProps,
	credsServiceWorkspaceIsWrong: { type: Boolean },
	selectedApp: { type: Object },
};
